import React from 'react';
import Component from 'components/Starfield';
import {connect} from 'react-redux';
import withRouter from 'utils/withRouter';

const Container = withRouter(connect(
	(state, ownProps) => ({}),
	(dispatch, ownProps) => ({
		navigateTo: (location) => {
			// Use React Router v6 navigate function
			if (ownProps.navigate) {
				ownProps.navigate(location);
			}
		},
		// React.lazy() doesn't have a preload method, but the component
		// will load automatically when navigating to it
		preloadGallery: () => {
			// No-op: lazy components load on demand
		}
	})
)(Component));
export default Container;